// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.breadcrumb {
  font-size: 13px;
}
.breadcrumb a {
  text-decoration: none;
}
.breadcrumb .mat-icon {
  font-size: 20px;
  height: 20px;
  width: 20px;
  padding: 0 6px;
}
.breadcrumb .breadcrumb-title.active {
  text-transform: uppercase;
  font-weight: 500;
}
.breadcrumb .breadcrumb-item + .breadcrumb-item:before {
  display: inline-block;
  padding-right: 0.5rem;
  padding-left: 0.5rem;
  content: "/";
}`, "",{"version":3,"sources":["webpack://./src/app/shared/breadcrumb/breadcrumb.component.scss"],"names":[],"mappings":"AAGA;EACI,eAAA;AAFJ;AAGI;EACI,qBAAA;AADR;AAGI;EACI,eAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;AADR;AAGI;EACI,yBAAA;EACA,gBAAA;AADR;AAGI;EACI,qBAAA;EACA,qBAAA;EACA,oBAAA;EACA,YAAA;AADR","sourcesContent":["// ==========================================================================\r\n// Component: Breadcrumb.component\r\n// ==========================================================================\r\n.breadcrumb{\r\n    font-size: 13px;\r\n    a{\r\n        text-decoration: none;\r\n    }\r\n    .mat-icon{\r\n        font-size: 20px;\r\n        height: 20px;\r\n        width: 20px;\r\n        padding: 0 6px;\r\n    }\r\n    .breadcrumb-title.active{\r\n        text-transform: uppercase;\r\n        font-weight: 500;\r\n    }\r\n    .breadcrumb-item+.breadcrumb-item:before{\r\n        display: inline-block;\r\n        padding-right: .5rem;\r\n        padding-left: .5rem;\r\n        content: \"/\";\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
